import { theme } from 'theme'
import styled from 'particles/themes/styled'

interface InputContainerProps {
    width?: string
    isError?: boolean
}
interface TextInputContainerProps extends InputContainerProps {
    isReverse?: boolean
    displayColumn?: boolean
    icon?: boolean
    textAreaHeight?: string | number
    isBullet?: boolean
}
interface NumberInputContainerProps extends InputContainerProps {
    isDisable: boolean
    isInputMode: boolean
    isFilled: boolean
}
export const TextInputContainer = styled.div<TextInputContainerProps>`
    width: ${({ width }): string => (width ? width : '289px')};
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    @media screen and (max-width: 768px) {
        width: 100%;
    }
    .input-area-container {
        margin-bottom: ${theme.newSpacing.xxs};
    }
    .input-area {
        width: 100%;
        display: grid;
        grid-template-columns: ${({ displayColumn, icon }): string => (displayColumn || !icon ? '1fr' : 'auto 1fr')};
        align-items: center;
        justify-content: center;
        height: 38px;
        border: 1px solid ${theme.newColors.neutral200};
        border-radius: 4px;
        padding: 0px 12px;
        box-sizing: border-box;
        svg {
            max-width: 28px;
            justify-self: center;
            order: ${({ isReverse }): number => (isReverse ? 1 : 0)};
        }
        .input-box {
            width: 100%;
            display: flex;
            height: fit-content;
            justify-content: space-between;
            align-items: center;
            input {
                width: 100%;
                border: none;
                height: 100%;
                padding: 0;
                font-size: ${theme.newFontSizes.s};
                &::placeholder {
                    color: ${theme.newColors.neutral400};
                }
                &:focus {
                    outline: none;
                    padding: 0;
                }
                &:-webkit-autofill,
                &:-webkit-autofill:hover,
                &:-webkit-autofill:focus,
                &:-webkit-autofill:active {
                    -webkit-box-shadow: 0 0 0 30px ${theme.newColors.neutral50} inset !important;
                }
            }
        }

        &.disable {
            .select-display {
                cursor: default;
            }
            border-color: ${theme.newColors.neutral200};
            background-color: ${theme.newColors.neutral100};
            input {
                &:-webkit-autofill,
                &:-webkit-autofill:hover,
                &:-webkit-autofill:focus,
                &:-webkit-autofill:active {
                    -webkit-box-shadow: 0 0 0 30px ${theme.newColors.neutral100} inset !important;
                }
            }
        }
    }
    .textarea-input {
        position: relative;
        border: 1px solid
            ${({ isError }): string => (isError ? theme.newColors.alertError200 : theme.newColors.neutral200)};
        border-radius: 4px;
        box-sizing: border-box;
        height: fit-content;
        margin-bottom: ${theme.newSpacing.xxs};
        textarea {
            width: 100%;
            min-height: ${({ textAreaHeight }): string | number => (textAreaHeight ? textAreaHeight : '76px')};
            border: none;
            resize: none;
            overflow: auto;
            padding: ${theme.newSpacing.s};
            font-size: ${theme.newFontSizes.s};
            outline: none;
            color: ${theme.newColors.neutral500};
            &:focus {
                color: ${theme.colors.black};
            }
            &::-webkit-scrollbar {
                display: none;
            }
        }
        .tooltip-icon {
            right: 8.5px;
            top: ${theme.newSpacing.s};
            position: absolute;
        }
    }
    .bullet-list-input {
        position: relative;
        border: 1px solid
            ${({ isError }): string => (isError ? theme.newColors.alertError200 : theme.newColors.neutral200)};
        border-radius: 4px;
        box-sizing: border-box;
        height: fit-content;
        svg {
            position: absolute;
            max-width: 28px;
            justify-self: center;
            right: ${theme.newSpacing.xxs};
            top: ${theme.newSpacing.xxs};
        }
        .dot {
            position: absolute;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: ${theme.newColors.neutral400};
            top: ${theme.newSpacing.m};
            left: ${theme.newSpacing.s};
        }
        .input-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: ${theme.newSpacing.xxs} 0;
            textarea {
                width: 100%;
                border: none;
                height: ${({ textAreaHeight }): string | number => {
                    if (!textAreaHeight) {
                        return '18px'
                    }
                    if (typeof textAreaHeight === 'number') {
                        return textAreaHeight + 'px'
                    }
                    return textAreaHeight
                }};
                padding: ${({ isBullet }) =>
                    `0 ${theme.newSpacing.xl} 0 ${isBullet ? theme.newSpacing.xl : theme.newSpacing.s}`};
                font-size: ${theme.newFontSizes.s};
                outline: none;
                resize: none;
                &::placeholder {
                    color: ${theme.newColors.neutral400};
                }
                &:focus {
                    outline: none;
                }
                &:-webkit-autofill,
                &:-webkit-autofill:hover,
                &:-webkit-autofill:focus,
                &:-webkit-autofill:active {
                    -webkit-box-shadow: 0 0 0 30px ${theme.newColors.neutral50} inset !important;
                }
                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }
    }

    .text-area {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: ${theme.newFontSizes.xs};
        .error {
            color: ${theme.newColors.alertError200};
            margin: 0;
        }
        .counter {
            color: ${theme.newColors.neutral500};
            justify-self: flex-end;
            display: flex;
            .error {
                color: ${theme.newColors.alertError200};
            }
        }
    }
    .error-border {
        border-color: ${theme.newColors.alertError200} !important;
    }
    .close-btn {
        cursor: pointer;
    }
`
export const NumberInputContainer = styled.div<NumberInputContainerProps>`
    width: fit-content;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 768px) {
        width: 100%;
    }
    .input-area {
        width: ${({ width }): string => (width ? width : '289px')};
        display: flex;
        align-items: center;
        height: 38px;
        border: 1px solid
            ${({ isError }): string => (isError ? theme.newColors.alertError200 : theme.newColors.neutral200)};
        border-radius: 4px;
        padding: 0px 12px;
        box-sizing: border-box;
        margin-bottom: ${theme.newSpacing.xxs};
        .input-box {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .dollar-sign {
                margin-right: ${theme.newSpacing.xxxs};
                line-height: 100%;
            }
            .price-prefix {
                font-size: ${theme.newFontSizes.s};
                color: ${({ isDisable, isInputMode, isFilled }): string => {
                    if (isDisable) {
                        return theme.newColors.neutral700
                    }
                    if (!isDisable && !isFilled && !isInputMode) {
                        return theme.newColors.neutral400
                    } else {
                        return theme.colors.black
                    }
                }};
            }
            input {
                width: 100%;
                border: none;
                height: 100%;
                padding: 0;
                font-size: ${theme.newFontSizes.s};
                background-color: transparent;
                color: ${({ isDisable }): string => (isDisable ? theme.newColors.neutral700 : theme.colors.black)};
                &::placeholder {
                    color: ${({ isDisable }): string =>
                        isDisable ? theme.newColors.neutral700 : theme.newColors.neutral400};
                }
                &:focus {
                    outline: none;
                    padding: 0;
                }
                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
            }
        }

        &.disable {
            .select-display {
                cursor: default;
            }
            border-color: ${theme.newColors.neutral200};
            background-color: ${theme.newColors.neutral100};
        }
    }

    .error {
        font-size: ${theme.newFontSizes.xs};
        min-height: 28px;
        color: ${theme.newColors.alertError200};
    }
`
interface ToggleProps {
    width: string
    height: string
}
export type ShareButtonSize = 's' | 'm' | 'l'

export const ToggleReadOnly = styled.div<ToggleProps>`
    width: ${({ width }) => (width ? width : '42px')};
    min-width: ${({ width }) => (width ? width : '42px')};
    height: ${({ height }) => (height ? height : '42px')};
    margin-right: 12px;
    display: flex;
    justify-content: center;
`

export const RadioReadOnlyContainer = styled.div<{ size?: ShareButtonSize }>`
    display: flex;
    align-items: center;
    gap: ${({ size }) => (size === 's' ? '13px' : size === 'l' ? '15px' : '14px')};
    &::before {
        content: '';
        width: ${({ size }) => (size === 's' ? '10px' : size === 'l' ? '14px' : '12px')};
        height: ${({ size }) => (size === 's' ? '10px' : size === 'l' ? '14px' : '12px')};
        background-color: ${theme.newColors.neutral700};
        border-radius: 50%;
    }
`
interface CheckBoxRadioGroupContainerProps {
    isDisplayRow: boolean
    isCheck?: boolean
    size?: ShareButtonSize
}
export const CheckBoxRadioGroupContainer = styled.div<CheckBoxRadioGroupContainerProps>`
    display: flex;
    flex-direction: column;
    .checkbox-group {
        display: flex;
        flex-direction: ${({ isDisplayRow }): string => (isDisplayRow ? 'row' : 'column')};
        gap: ${theme.newSpacing.m};
    }
    .selected-group {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .radio-group {
        display: flex;
        flex-direction: ${({ isDisplayRow }): string => (isDisplayRow ? 'row' : 'column')};
        gap: ${theme.newSpacing.xxs};
    }
    .input-group {
        display: flex;
        align-self: baseline;
        align-items: center;
        font-size: ${theme.newFontSizes.s};
        gap: ${theme.newSpacing.xxxxs};
        height: 20px;
        .selector-container {
            width: ${({ size }) => (size === 's' ? '28px' : size === 'l' ? '36px' : '32px')};
            height: ${({ size }) => (size === 's' ? '28px' : size === 'l' ? '36px' : '32px')};
            background-color: transparent;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            &:hover {
                background-color: ${theme.newColors.primary50};
            }
        }
        input[type='radio'] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            width: 14px;
            height: 14px;
            box-sizing: border-box;
            border-radius: 50%;
            border: 2px solid white;
            outline: 2px solid;
            cursor: pointer;
            background-color: ${({ isCheck }): string => (isCheck ? theme.newColors.primary300 : 'transparent')};
            outline-color: ${({ isCheck }): string =>
                isCheck ? theme.newColors.primary300 : theme.newColors.neutral400};
            position: relative;
            &::before {
                content: '';
                width: 250%;
                height: 250%;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                border: 1px solid ${theme.newColors.primary200};
                display: none;
                border-radius: 4px;
            }
            &:focus {
                &::before {
                    display: block;
                }
            }
            &:checked {
                background-color: ${theme.newColors.primary300};
                outline-color: ${theme.newColors.primary300};
                &:disabled {
                    background-color: ${theme.newColors.neutral400};
                }
                &::before {
                    display: none;
                }
            }
            &:disabled {
                outline-color: ${theme.newColors.neutral400};
                cursor: not-allowed;
                &::before {
                    display: none;
                }
            }
        }

        input.check-box {
            cursor: pointer;
            width: ${({ size }) => (size === 's' ? '16px' : size === 'l' ? '24px' : '20px')};
            height: ${({ size }) => (size === 's' ? '16px' : size === 'l' ? '24px' : '20px')};
            position: relative;
            &::before {
                content: '';
                width: 125%;
                height: 125%;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                border: 1px solid ${theme.newColors.primary200};
                display: none;
                border-radius: 4px;
            }
            &:focus {
                &::before {
                    display: block;
                }
            }
            &:checked {
                &::before {
                    display: none;
                }
            }
            &:disabled {
                cursor: not-allowed;
                &::before {
                    display: none;
                }
            }
        }
    }
    .error {
        font-size: ${theme.newFontSizes.xs};
        color: ${theme.newColors.alertError200};
    }
`
